import PageHeader from "@/components/site/PageHeader";
import SectionHeader from "@/components/site/SectionHeader";
import { Card } from "@/components/ui/card";
import {
  Wallet,
  Gift,
  TrendingUp,
  Home as HomeIcon,
  Utensils,
  CalendarCheck,
  Clock,
  Award,
  CalendarDays,
} from "lucide-react";
import { IMAGES } from "@/lib/brand";

const BENEFITS = [
  {
    icon: Wallet,
    title: "PF after 3 months",
    desc: "Provident Fund contribution begins after 3 months of continuous service.",
  },
  {
    icon: Gift,
    title: "Bonus after 6 months",
    desc: "Performance and attendance-based bonus paid after 6 months.",
  },
  {
    icon: TrendingUp,
    title: "Increment after 9 months",
    desc: "Salary revision based on performance after 9 months of service.",
  },
  {
    icon: HomeIcon,
    title: "Accommodation facilities",
    desc: "Safe, hygienic accommodation arranged near deployment sites.",
  },
  {
    icon: Utensils,
    title: "Nutritious meals",
    desc: "Tiffin, Lunch, Coffee, and Dinner provided as per shift.",
  },
  {
    icon: CalendarCheck,
    title: "Salary before 8th every month",
    desc: "On-time payroll disbursement, no delays, no excuses.",
  },
  {
    icon: Clock,
    title: "Overtime as per norms",
    desc: "OT calculated and disbursed as per statutory guidelines.",
  },
  {
    icon: Award,
    title: "Attendance incentives",
    desc: "Monthly attendance-based incentives for consistent workers.",
  },
  {
    icon: CalendarDays,
    title: "3 leave days per month",
    desc: "Adequate leave allowance to support work-life balance.",
  },
];

export default function EmployeeBenefitsPage() {
  return (
    <div data-testid="employee-benefits-page">
      <PageHeader
        eyebrow="Employee Benefits"
        title="A workplace that takes care of its workforce"
        description="Comprehensive welfare, statutory compliance, and on-time disbursements — built into every engagement."
        image={IMAGES.femaleEngineer}
      />

      <section className="py-16 md:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHeader
            eyebrow="What you get"
            title="Benefits at every milestone"
            description="From statutory contributions to accommodation and meals — every detail is taken care of."
            testid="employee-benefits-header"
          />
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {BENEFITS.map((b, i) => {
              const Icon = b.icon;
              return (
                <Card
                  key={b.title}
                  data-testid={`benefit-card-${i}`}
                  className="rk-lift p-6 sm:p-7 bg-white border border-[#E2E8F0] rounded-sm rk-fade-up"
                  style={{ animationDelay: `${i * 60}ms` }}
                >
                  <div className="flex items-start gap-4">
                    <div className="h-11 w-11 grid place-items-center rounded-sm bg-[#1F6B5C]/10 text-[#1F6B5C] shrink-0">
                      <Icon className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-display font-bold text-[#0F172A] text-lg">
                        {b.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-[#475569]">
                        {b.desc}
                      </p>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
